"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConversationOutputDtoSchema = exports.createConversationInputDtoSchema = void 0;
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const conversation_summary_dto_js_1 = require("./conversation-summary.dto.js");
exports.createConversationInputDtoSchema = zod_1.z.object({
    projectId: zod_1.z
        .string()
        .regex((0, cadstrom_shared_1.cadstromUidRegex)(cadstrom_shared_1.CadstromObjectType.Project), { message: 'projectId must be a valid project id' })
        .optional(),
    revisionId: zod_1.z
        .string()
        .regex((0, cadstrom_shared_1.cadstromUidRegex)(cadstrom_shared_1.CadstromObjectType.Build), { message: 'revisionId must be a valid build id' })
        .optional(),
    packageId: zod_1.z
        .string()
        .regex((0, cadstrom_shared_1.cadstromUidRegex)(cadstrom_shared_1.CadstromObjectType.PackageStorePackage), {
        message: 'packageId must be a valid package id',
    })
        .optional(),
    sessionId: zod_1.z.guid(),
    agentId: zod_1.z.string().min(1),
});
exports.createConversationOutputDtoSchema = conversation_summary_dto_js_1.conversationSummaryDtoSchema;
//# sourceMappingURL=create-conversation.dto.js.map